module.exports = __webpack_public_path__ + "img/logout.41bbea01.svg";